/**
 * The registers the Cost Databank holds.
 *
 * One list, used by the landing page that offers them. It lived in the sidebar
 * as ten menu entries, which pushed every other thing the portal does further
 * down the page for the sake of a section most members open once a month.
 *
 * Adding a register is a line here and a route; the screen behind them all is
 * the same one.
 */

export type DatasetEntry = {
  key: string;
  label: string;
  /** What a quantity surveyor would actually look this up for. */
  blurb: string;
};

export const DATASETS: DatasetEntry[] = [
  {
    key: "basic_price_list",
    label: "Basic Price List",
    blurb: "Materials at the gate — cement, rods, blocks — by state and month.",
  },
  {
    key: "unit_rates",
    label: "Unit Rates",
    blurb: "Built-up rates for finished work, measured per unit.",
  },
  {
    key: "composite_rates",
    label: "Composite Rates",
    blurb: "Rates covering a whole assembly rather than a single trade.",
  },
  {
    key: "plant_hire_rates",
    label: "Plant Hire Rates",
    blurb: "What plant costs to hire, by the hour, day or month.",
  },
  {
    key: "labour_rates",
    label: "Labour Rates",
    blurb: "What each trade is paid, by state and period.",
  },
  {
    key: "labour_outputs",
    label: "Labour Outputs",
    blurb: "How much work a trade completes in a day — the basis of a rate build-up.",
  },
  {
    key: "constants",
    label: "Constants",
    blurb: "The multipliers and allowances that go into a rate.",
  },
  {
    key: "infrastructure_benchmarks",
    label: "Infrastructure Benchmarks",
    blurb: "Cost per kilometre, per square metre, per bed — for order-of-magnitude figures.",
  },
];
